import React from "react";
import {PaymentItemEntity} from "@dropDesk/domain/entities/payment/payment.entity";
import {PaymentItemType} from "@dropDesk/domain/entities/payment/payment.enum";
import {ColorScheme} from "@dropDesk/domain/entities/theme/color_scheme";
import {formatCurrency} from "@dropDesk/utils/helpers/common";
import DropDeskIcon from "@dropDesk/storage/icons";
import {ICONS_DROPDESK} from "@dropDesk/storage/icons/icons.d";
import {
    TableRow,
    TableCell,
    ItemCellContent,
    IconWrapper,
    ItemLabel,
} from "./styled";

const InvoiceItem = ({item, periodFormatted, colors}: {
    item: PaymentItemEntity;
    periodFormatted: string;
    colors: ColorScheme;
}) => {
    const isExtension = item.type === PaymentItemType.extension;

    const icon = isExtension ? ICONS_DROPDESK.extension : ICONS_DROPDESK.subscription;
    const typeLabel = isExtension ? 'Extensão' : 'Plano';

    return (
        <TableRow borderColor={colors.border}>
            <TableCell color={colors.text}>
                <ItemCellContent>
                    <IconWrapper background={colors.delicateBackground} color={colors.accent}>
                        <DropDeskIcon icon={icon} size={15} color={colors.accent}/>
                    </IconWrapper>
                    <ItemLabel color={colors.accent}>{typeLabel}</ItemLabel>
                </ItemCellContent>
            </TableCell>
            <TableCell color={colors.text}>{item.description}</TableCell>
            <TableCell color={colors.text}>{periodFormatted}</TableCell>
            <TableCell color={colors.text}>{formatCurrency(item.value)}</TableCell>
        </TableRow>
    );
};

export default InvoiceItem;
